import SubscriptionRecapStatus from "./SubscriptionRecapStatus";
import SubscriptionRecapCurrentPlan from "./SubscriptionRecapCurrentPlan";
import SubscriptionRecapCoupon from "./SubscriptionRecapCoupon";
import SubscriptionRecapNextInvoice from "./SubscriptionRecapNextInvoice";

function SubscriptionRecap({ nextInvoiceSubscriptionAmount, currentCoupon }) {
  return (
    <div
      className="mb-4 d-flex flex-column"
      data-testid="manage-subscription-recap-section"
    >
      <SubscriptionRecapStatus />
      <SubscriptionRecapCurrentPlan />
      <SubscriptionRecapCoupon currentCoupon={currentCoupon} />
      <SubscriptionRecapNextInvoice nextInvoiceSubscriptionAmount={nextInvoiceSubscriptionAmount} />
    </div>
  );
}

export default SubscriptionRecap;
